// removed by extract-text-webpack-plugin
module.exports = {"popover":"src-utils-forms----fields-module---popover---Z7q9H fontSize-s fontWeight-5 lineHeight-s paddingLeftRight-xs textAlign-center truncateText","label":"src-utils-forms----fields-module---label---ekyA0 c-black fontSize-m fontWeight-5 lineHeight-m marginBottom-xxs"};


//////////////////
// WEBPACK FOOTER
// ./src/utils/forms/fields.module.css
// module id = 486
// module chunks = 168707334958949